import * as React from 'react';
import styled from 'styled-components';

// ############################ Imported from Old UI ###########################
// ############################ Styles ###########################
// tslint:disable:variable-name

const SHiddenElement = styled.span`
  overflow: hidden;
`;
// tslint:enable:variable-name
// ############################ End Styles ###########################

interface IHiddenLabelProps {
  label: string;
  focusOnMount?: boolean;
}

// after TAB-ing the submit - focus on other element immediately
// tslint:disable-next-line: variable-name
const HiddenLabel: React.FC<IHiddenLabelProps> = ({ label, focusOnMount = true }) => {
  const elementRef = React.useRef<HTMLSpanElement>(null);

  React.useEffect(() => {
    if (focusOnMount && elementRef && elementRef.current) {
      elementRef.current.focus();
    }
  }, []);

  return <SHiddenElement ref={elementRef} aria-label={label} tabIndex={0} />;
};

export default HiddenLabel;
